<template>
  <div>
    <csqc-table class="tableau" :liste="listeCSSParticipantes" :colonnes="colonnesTableau" :btnModifier="false"
      :btnSupprimer="false" :btnAjouter="false" :boiteRecherche="false" :showSelect="false" :itemsParPage=[-1]>
      <template v-slot:[`item.nomCSS`]="{ item }">
        <div v-if="item.lienSiteWeb != null && item.lienSiteWeb != '-1'">
          <a :href="item.lienSiteWeb" target="_blank">{{ item.nomCSS }}</a>
        </div>
        <div v-else-if="item.lienSiteWebExam != null && item.lienSiteWebExam != '-1'">
          <a :href="item.lienSiteWebExam" target="_blank">{{ item.nomCSS }}</a>
        </div>
        <div v-else>
          {{ item.nomCSS }}
        </div>
      </template>
      <!-- Virtuel -->
      <template v-slot:[`item.virtuel`]="{ item }">
        <div v-if="item.virtuel">
          <v-icon style="margin-left:10px">mdi-check</v-icon>
        </div>
      </template>

      <!-- Présentiel -->
      <template v-slot:[`item.presentiel`]="{ item }">
        <div v-if="item.lienSiteWeb != '-1' && item.lienSiteWeb != null">
          <v-icon style="margin-left:20px">mdi-check</v-icon>
        </div>
      </template>
      <!-- Reprise épreuve -->
      <template v-slot:[`item.repriseEpreuve`]="{ item }">
        <div v-if="item.lienSiteWebExam != '-1' && item.lienSiteWebExam != null">
          <v-icon style="margin-left:20px">mdi-check</v-icon>
        </div>
      </template>
    </csqc-table>
  </div>
</template>

<script>
import useInscriptionStore from '@/store/inscriptionStore';
import CsqcTable from 'csqc-composants-ui/src/CsqcTable/csqc-table.vue';

export default {
  name: 'CSSParticipantesTable',
  components: {
    'csqc-table': CsqcTable,
  },
  setup() {
    const inscriptionStore = useInscriptionStore();

    return { inscriptionStore };
  },
  data() {
    return {
      listeCSSParticipantes: [],
      listeCSSMinimises: [],
    };
  },
  async created() {
    // Obtention des CSS minimisés
    this.listeCSSMinimises = this.inscriptionStore.listeCssMinimise;
    await this.gestionTableCSSParticipants();
  },
  methods: {
    async gestionTableCSSParticipants() {
      // Obtention des optionsCSS selon les CSS minimisés
      for (let cpt = 0; cpt < this.listeCSSMinimises.length; cpt += 1) {
        // TODO: Modifier await this.optionCss(this.listeCSSMinimises[cpt].cssId); pour ne pas garder un await dans la boucle
        // eslint-disable-next-line no-await-in-loop
        const optionCss = await this.inscriptionStore.obtenirOptionCss(this.listeCSSMinimises[cpt].cssId);

        if (optionCss != null) {
          const contientLienPresentiel = optionCss.urlPlateformeLocale != null;
          const contientLienExamen = optionCss.urlPlateformeLocaleExam != null;

          // Gestion de l'affichage dans la table
          if (contientLienPresentiel && !contientLienExamen) {
            // Contient juste l'URL en présentiel
            this.listeCSSParticipantes.push({
              nomCSS: this.listeCSSMinimises[cpt].nom, virtuel: true, lienSiteWeb: optionCss.urlPlateformeLocale, id: optionCss.id,
            });
          } else if (!contientLienPresentiel && contientLienExamen) {
            // Contient juste l'URL de la reprise d'épreuves uniques
            this.listeCSSParticipantes.push({
              nomCSS: this.listeCSSMinimises[cpt].nom, virtuel: true, repriseEpreuve: true, lienSiteWebExam: optionCss.urlPlateformeLocaleExam, id: optionCss.id,
            });
          } else if (contientLienPresentiel && contientLienExamen) {
            // Contient les 2 liens mentionnés plus haut
            this.listeCSSParticipantes.push({
              nomCSS: this.listeCSSMinimises[cpt].nom,
              virtuel: true,
              repriseEpreuve: true,
              lienSiteWeb: optionCss.urlPlateformeLocale,
              lienSiteWebExam: optionCss.urlPlateformeLocaleExam,
              id: optionCss.id,
            });
          } else {
            // Aucun lien dans les 2
            this.listeCSSParticipantes.push({ nomCSS: this.listeCSSMinimises[cpt].nom, virtuel: true, id: optionCss.id });
          }
        }
      }

      // Table mise en ordre alphabétique
      // eslint-disable-next-line max-len, no-nested-ternary
      this.listeCSSParticipantes = this.listeCSSParticipantes.sort((a, b) => ((a.nomCSS.toLowerCase() > b.nomCSS.toLowerCase()) ? 1 : ((b.nomCSS.toLowerCase() > a.nomCSS.toLowerCase()) ? -1 : 0)));
    },
  },
  computed: {
    colonnesTableau() {
      let colonnes = [
        {
          text: this.$tc('accueil.panneau.nomCSS'),
          align: 'start',
          sortable: false,
          value: 'nomCSS',
          width: '40%',
          class: 'grey lighten-4',
        },
        {
          text: this.$tc('accueil.panneau.virtuel'),
          align: 'start',
          sortable: false,
          value: 'virtuel',
          width: '20%',
          class: 'grey lighten-4',
        },
        {
          text: this.$tc('accueil.panneau.presentiel'),
          align: 'start',
          sortable: false,
          value: 'presentiel',
          width: '20%',
          class: 'grey lighten-4',
        },
        {
          text: this.$tc('accueil.panneau.repriseEpreuve'),
          align: 'start',
          sortable: false,
          value: 'repriseEpreuve',
          width: '20%',
          class: 'grey lighten-4',
        },
      ];
      if (this.$vuetify.breakpoint.xs) {
        colonnes = [
          {
            text: this.$tc('accueil.panneau.nomCSS'),
            align: 'start',
            sortable: false,
            value: 'nomCSS',
            width: '40%',
            class: 'grey lighten-4 texteColonneXS',
          },
          {
            text: this.$tc('accueil.panneau.virtuel'),
            align: 'start',
            sortable: false,
            value: 'virtuel',
            width: '7%',
            class: 'grey lighten-4 texteColonneXS',
          },
          {
            text: this.$tc('accueil.panneau.presentiel'),
            align: 'start',
            sortable: false,
            value: 'presentiel',
            width: '7%',
            class: 'grey lighten-4 texteColonneXS',
          },
          {
            text: this.$tc('accueil.panneau.repriseEpreuve'),
            align: 'start',
            sortable: false,
            value: 'repriseEpreuve',
            width: '7%',
            class: 'grey lighten-4 texteColonneXS',
          },
        ];
      }
      return colonnes;
    },
  },
};
</script>

<style scoped>
.tableau {
  margin-bottom: 12px;
}

.tableau::v-deep .v-data-footer,
.tableau::v-deep .row:last-child>.col>div:last-child,
.tableau::v-deep .row:first-child>div:first-child {
  display: none;
}

.tableau::v-deep .row:first-child>div:last-child {
  max-width: 100%;
  flex: 0 0 100%;
}

.tableau::v-deep .row:first-child {
  margin-bottom: -27px;
}

.tableau::v-deep tr {
  cursor: auto;
}

.tableau::v-deep>div.row:last-child>div>div>div>table>tbody>tr>td {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
</style>
